import { render } from "./ReportInventoryReceiving.vue?vue&type=template&id=4ea052d6&scoped=true"
import script from "./ReportInventoryReceiving.vue?vue&type=script&lang=js"
export * from "./ReportInventoryReceiving.vue?vue&type=script&lang=js"

import "./ReportInventoryReceiving.vue?vue&type=style&index=0&id=4ea052d6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ea052d6"]])

export default __exports__